import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { YouthComponent } from './youth.component';
import { YouthHomeComponent } from './components/home/youth-home.component';
import { YouthAttachedComponent } from './components/attached/youth-attached.component';
import { YouthRankingComponent } from './components/ranking/list/youth-ranking.component';
import { YouthRankingClassifComponent } from './components/ranking/classification/youth-ranking-classif.component';
import { SharedAttachmentsDetailComponent } from '@theme/components';

const routes: Routes = [
    {
        path: '',
        component: YouthComponent,
        children: [
            { path: 'home', component: YouthHomeComponent },
            {
                path: 'tournament',
                loadChildren: () => import('../tournament/tournament.module').then((m) => m.TournamentModule),
            },
            { path: 'ranking-2', loadChildren: () => import('../ranking/ranking.module').then((m) => m.RankingModule) },
            { path: 'ranking', component: YouthRankingComponent },
            {
                path: 'ranking-classif/:rankingId',
                component: YouthRankingClassifComponent,
            },
            {
                path: 'attached/:sessionType',
                component: YouthAttachedComponent,
            },
            { path: 'attached/:sessionType/detail/:docId', component: SharedAttachmentsDetailComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class YouthRoutingModule {}
